// extracted by mini-css-extract-plugin
export default {"template-single__add":"SinglePromptAdd_template-single__add__-fjEI","template-single__add__border":"SinglePromptAdd_template-single__add__border__25UmR"};